<template>
  <div
    class="dui-char-count grid-flex grid-middle grid-no-response text-grey-dark"
    :class="{ 'text-red-base': invalidLength }"
  >
    <div
      v-if="invalidLength"
      class="grid-item-shrink"
    >
      Please delete some characters
    </div>
    <div class="grid-item text-right">
      <span>{{ currentLength }}</span><span v-if="maxLength">/{{ maxLength }}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    maxLength: {
      type: Number,
      default: null,
    },
    value: {
      type: String,
      default: null,
    },
  },
  computed: {
    currentLength() {
      return this.value ? this.value.length : 0;
    },
    invalidLength() {
      if (!this.maxLength || !this.value) {
        return false;
      }

      return (this.value.length > this.maxLength);
    },
  },
};
</script>
